/**
 * Which disciplines a project's tender covers. Both flags can be true (a
 * tender priced for groundworks *and* roads & sewers), and both can be false
 * when the tender hasn't picked a job type yet.
 *
 * Only groundworks is forecastable today — see `getProjectWorkType` for the
 * label/message logic that depends on that.
 */
export interface IProjectJobTypes {
  groundworks: boolean;
  roadsAndSewers: boolean;
}

/**
 * GET /project/{opportunityNo}/job-types
 *
 * Note the PascalCase wire names (`JobType`, `OpportunityNo` below) — these
 * two endpoints don't follow the camelCase of `/bc/projects`.
 */
export interface IProjectJobTypesRes {
  JobType: IProjectJobTypes;
}

/** One row of GET /project/job-types. */
export interface IProjectJobTypesListItem extends IProjectJobTypesRes {
  OpportunityNo: string;
}

/**
 * The job-type combinations a project can be in, flattened into the single
 * value the UI actually shows. `unknown` covers a project the job-types API
 * has no record for (or one with neither flag set).
 */
export type ProjectWorkType =
  | "groundworks"
  | "roadsAndSewers"
  | "both"
  | "unknown";

export const PROJECT_WORK_TYPE_LABEL: Record<ProjectWorkType, string> = {
  groundworks: "Groundworks",
  roadsAndSewers: "Roads & Sewers",
  both: "Groundworks + R&S",
  unknown: ""
};

export const getProjectWorkType = (
  jobTypes: IProjectJobTypes | undefined
): ProjectWorkType => {
  if (!jobTypes) return "unknown";
  if (jobTypes.groundworks && jobTypes.roadsAndSewers) return "both";
  if (jobTypes.groundworks) return "groundworks";
  if (jobTypes.roadsAndSewers) return "roadsAndSewers";
  return "unknown";
};
